import i18n from '@benzinga/translate';

export const _mockMenu = {
  featuredMenu: [
    {
      href: 'https://www.benzinga.com/apis',
      title: 'Data & APIs',
    },
    {
      href: 'https://www.benzinga.com/events',
      title: 'Events',
    },
    {
      href: 'https://www.benzinga.com/premarket',
      title: 'Premarket',
    },
    {
      href: 'https://advertise.benzinga.com',
      title: 'Advertise',
    },
  ],
  marketsQuotes: [
    {
      change: 1.5,
      exchange: 'NYSE',
      name: 'Ford Motor',
      price: 300,
      symbol: 'F',
    },
    {
      change: 1.5,
      exchange: 'NYSE',
      name: 'MasterCard',
      price: 0.3,
      symbol: 'MA',
    },
    {
      change: 1.3,
      exchange: 'NASDAQ',
      name: 'Tesla',
      price: 0.023,
      symbol: 'TSLA',
    },
    {
      change: -2.1,
      exchange: 'OTC',
      name: 'Airbus',
      price: 0.0042341,
      symbol: 'EADSF',
    },
    {
      change: 1.3,
      exchange: 'NYSE',
      name: 'Salesforce.com',
      price: 300,
      symbol: 'CRM',
    },
  ],
  menus: [
    {
      href: 'https://www.benzinga.com/news',
      menuItems: [
        {
          href: 'https://www.benzinga.com/earnings',
          title: 'Earnings',
        },
        {
          href: 'https://www.benzinga.com/guidance',
          title: 'Guidance',
        },
        {
          href: 'https://www.benzinga.com/dividends',
          title: 'Dividends',
        },
      ],
      title: 'News',
    },
    {
      href: 'https://www.benzinga.com/markets',
      menuItems: [
        {
          href: 'https://www.benzinga.com/premarket',
          title: 'Pre-Market',
        },
      ],
      title: 'Markets',
    },
    {
      href: 'https://www.benzinga.com/analyst-stock-ratings',
      menuItems: [
        {
          href: 'https://www.benzinga.com/analyst-ratings/analyst-color',
          title: 'Analyst Color',
        },
      ],
      title: 'Ratings',
    },
    {
      href: 'https://www.benzinga.com/tading-ideas',
      menuItems: [
        {
          href: 'https://www.benzinga.com/tading-ideas/long-ideas',
          title: 'Long Ideas',
        },
      ],
      title: 'Investing Ideas',
    },
    {
      href: 'https://www.benzinga.com/fintech',
      title: 'Fintech',
    },
    {
      href: 'https://www.benzinga.com/money',
      menuItems: [
        {
          href: 'https://www.benzinga.com/money/best-online-brokers',
          title: 'Best Online Brokers',
        },
      ],
      title: 'Brokerage Reviews',
    },
    {
      href: 'https://www.benzinga.com/money/crypto',
      title: 'Crypto',
    },
    {
      href: 'https://www.benzinga.com/video',
      menuItems: [
        {
          href: 'https://www.youtube.com/benzinga',
          title: 'YouTube',
        },
      ],
      title: 'TV',
    },
  ],
  recentQuotes: [
    {
      change: 1.5,
      exchange: 'NYSE',
      name: 'Ford Motor',
      price: 777,
      symbol: 'F',
    },
    {
      change: 1.5,
      exchange: 'NYSE',
      name: 'MasterCard',
      price: 458.9,
      symbol: 'MA',
    },
    {
      change: 1.3,
      exchange: 'NASDAQ',
      name: 'Tesla',
      price: 358.0,
      symbol: 'TSLA',
    },
  ],
};

export const featuredMenu = [
  {
    href: 'https://www.benzinga.com/apis',
    title: i18n.t(`Navigation.TopBar.DataAndAPIs`),
  },
  {
    href: 'https://www.benzinga.com/events',
    title: i18n.t(`Navigation.TopBar.Events`),
  },
  {
    href: 'https://www.benzinga.com/premarket',
    title: i18n.t(`Navigation.TopBar.Premarket`),
  },
  {
    href: 'https://advertise.benzinga.com',
    title: i18n.t(`Advertise`),
  },
];

export const DefaultQuotesList = ['SPY', 'QQQ', 'BTC/USD', 'DIA', 'GLD', 'TLT'];

export const convertToRelativeUrl = (url: string) => url?.replace('https://www.benzinga.com/', '/');
